import React, { useState, createContext } from "react";
import { Fetch } from "../hooks/use-fetch-hook";
import { showSuccessMessage } from "../helpers/useToast";
import { format } from 'date-fns';

export const PastoralContext = createContext(null);

export const PastoralProvider = ({ children }) => {
  const [followUps, setFollowUps] = useState(null);
  const [followUp, setFollowUp] = useState(null);
  const [isUpdated, setIsUpdated] = useState(false);
  const [isOnCall, setIsOnCall] = useState(false);
  const [callSettings, setCallSettings] = useState([]);
  const [activeTopBar, setActiveTopBar] = useState(null);
  const [activeSideBar, setActiveSideBar] = useState(1);
  const [isMute, setIsMute] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [searchValue, setSearchValue] = useState();
  const [sortBy, setSortBy] =useState();
  const [sortOrder, setSortOrder] =useState();

  const [filter, setFilter] = useState("");

  const setSort =(field)=>
  {
     
      switch(field)
      {
        case "newDate":
          setSortBy('created_at');
          break;
        case 'followupDate':
            setSortBy('follow_up_date');
          break;
        case 'followupType':
            setSortBy('follow_up_type');
            break;
        case 'partner':
              setSortBy('agent_name');
              break;
        case 'closingDate':
            setSortBy('closing_date');
            break;
        default:
                setSortBy('created_at');
        
          
      }   
      sortOrder ==='desc'?
          setSortOrder('asc'):setSortOrder('desc');
  }

  const getFollowUps = async (status, page) => {
     var url = process.env.REACT_APP_API_URL + `/follow_ups?status=`;
     if(status === 'checkin'){
      url +='completed&checkin=1';
    }
     else
    url += status;
    //pagination
    if (page) url += "&page=" + page;

    //sorting
    if (sortBy && sortOrder) 
      {
        url += "& sort_by="+sortBy+"& sort_order="+sortOrder
      }
    //searching
    if (filter && searchValue) 
      {
        var filterParam="";
        var searchTerm = searchValue;
        
        // Normalize phone number if searching by phone
        if (filter === 'user_number') {
          searchTerm = normalizePhoneNumber(searchValue);
        }
        
        switch(filter)
        {
          case 'agent_name':
          case 'user_number':
          case 'caller_name':
          case 'follow_up_type':
          case 'twilio_number':
            filterParam = "&" + filter +'='+encodeURIComponent(searchTerm);
            break;
          case 'date_range':
            filterParam = "&" + filter +'='+format(searchValue[0], 'yyyy-MM-dd')+','+format(searchValue[1], 'yyyy-MM-dd');

            break;
         
          default:
            filterParam = "&" + filter +'='+searchTerm;
        }
        url +=filterParam ;

      }

    var options = {
      method: "GET",

      headers: {
        "Content-Type": "application/json",
        Authorization: process.env.REACT_APP_API_AUTHORIZATION,
      },
    };
    try {
      const result = await fetch(url, options);
      if (!result.ok) {
        throw new Error("Network response was not ok");
      }
      return await result.json();
    } catch (err) {
      return err.message;
    }
  };

  const getResources = async (status, page) => {
    var url =
      process.env.REACT_APP_API_URL + `/resource/physical`;
      var paramCount = 0;
      const appendSign = ()=>{
       var result= paramCount === 0 ? '?':'&';
        paramCount++;
        return result;
      }
      if (status.length > 0) 
        {
          url += appendSign() +"status="+status;
        }

      if (page) url += appendSign() +"page=" + page;

        //searching
    if (filter && searchValue) 
      {
        var filterParam="";
        switch(filter)
        {
          case 'agent_name':
          case 'caller_name':
          case 'user_number':
            filterParam = appendSign()  + filter +'='+encodeURIComponent(searchValue);
            break;
        
          default:
            filterParam = appendSign()  + filter +'='+searchValue;
        }
        url +=filterParam ;

      }

    var options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: process.env.REACT_APP_API_AUTHORIZATION,
      },
    };

    const result = await fetch(url, options);
    return await result.json();
  };

  const getResourcesStatus = async (status, page) => {
    var url =
      process.env.REACT_APP_API_URL + `/resource/status`;
     
    var options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: process.env.REACT_APP_API_AUTHORIZATION,
      },
    };

    const result = await fetch(url, options);
    return await result.json();
  };

  const updateResource = async (id, sent_by) => {
    const url = process.env.REACT_APP_API_URL + "/prayerresource/updatePhyResc";

    var options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: process.env.REACT_APP_API_AUTHORIZATION,
      },
      body: JSON.stringify({ id, sent_by }),
    };
    const result = await Fetch(url, options);
    return await result.json();
  };
  

  const getFollowUp = async (id) => {
    const url = process.env.REACT_APP_API_URL + `/call_detail?id=${id}`;
    var options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: process.env.REACT_APP_API_AUTHORIZATION,
      },
    };

    const result = await fetch(url, options);
    return await result.json();
  };

  const updateFollowUp = async (requestObj) => {
    const url = process.env.REACT_APP_API_URL + "/call_detail";
    var options = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": process.env.REACT_APP_API_AUTHORIZATION,
        "Accept": 'application/json',
        
      },
      body: JSON.stringify(requestObj),
    };
    
    try {
      const response = await Fetch(url, options);
      
      // Check if the API call was successful
      if (response && response.error) {
        throw new Error(response.data?.error || response.data?.message || 'Failed to update follow-up');
      }
      
      // Verify we got a valid response
      if (!response || !response.data) {
        throw new Error('Invalid response from server');
      }
      
      setIsUpdated(true);
      showSuccessMessage(
        requestObj.status === 2
          ? "Follow Up Closed Successfully"
          : "Follow Up Updated Successfully"
      );
      
      return response;
    } catch (error) {
      console.error('Error updating follow-up:', error);
      setIsUpdated(false);
      throw error; // Re-throw so calling code can handle it
    }
  };

  const getCallLogs = async (requestObj) => {
    var url =
      process.env.REACT_APP_API_URL +
      `/call_stats?direction=outgoing${requestObj.task_sid? '&taskSid='+requestObj.task_sid:''}${requestObj.agent_name?'&agent_name='+requestObj.agent_name:''}${requestObj.page? '&page='+requestObj.page:''}`;
         //searching
    if (filter && searchValue) 
      {
        var filterParam="";
        switch(filter)
        {     
          case 'user_number':
            filterParam = "&caller_number="+encodeURIComponent(searchValue);
            break;
          case 'date_range':
            filterParam = "&start_date="+format(searchValue[0], 'yyyy-MM-dd')+'&end_date='+format(searchValue[1], 'yyyy-MM-dd');
            break;
         
          default:
            filterParam = "&" + filter +'='+searchValue;
        }
        url +=filterParam ;

      }

    var options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": process.env.REACT_APP_API_AUTHORIZATION,
        "Accept": 'application/json',
      },
    };
    const result = await fetch(url, options);

    return await result.json();
  };

  const getRepeatCalls = async (usernumber) => {
    const url =
      process.env.REACT_APP_API_URL +
      `/call_stats?caller_number=${encodeURIComponent(usernumber)}&direction=incoming&limit=3`;
    var options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": process.env.REACT_APP_API_AUTHORIZATION,
        "Accept": 'application/json',
      },
    };
    const result = await fetch(url, options);

    return await result.json();
  };

  const getCallStats = async (requestObj) => {
    const url =
      process.env.REACT_APP_API_URL +
      `/call_stats?called_number=${requestObj.called_number}`;

    var options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": process.env.REACT_APP_API_AUTHORIZATION,
        "Accept": 'application/json',
      },
    };
    const result = await fetch(url, options);

    return await result.json();
  };

  const getReportsData = async (requestObj) => {
    let url = process.env.REACT_APP_API_URL + `/reports`;
    
    // Add date range parameters if provided
    if (requestObj && (requestObj.startDate || requestObj.endDate)) {
      const params = new URLSearchParams();
      if (requestObj.startDate) {
        params.append('startDate', requestObj.startDate);
      }
      if (requestObj.endDate) {
        params.append('endDate', requestObj.endDate);
      }
      url += `?${params.toString()}`;
    }

    var options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": process.env.REACT_APP_API_AUTHORIZATION,
        "Accept": 'application/json',
      },
    };
    const result = await fetch(url, options);

    return await result.json();
  };

  // Helper function to normalize phone numbers for search
  const normalizePhoneNumber = (phone) => {
    if (!phone) return '';
    // Remove all non-digit characters except +
    let normalized = phone.replace(/[^\d+]/g, '');
    // If it starts with +1, keep it; otherwise ensure it starts with +
    if (normalized.startsWith('+1')) {
      return normalized;
    } else if (normalized.startsWith('1') && normalized.length === 11) {
      return '+' + normalized;
    } else if (normalized.length === 10) {
      return '+1' + normalized;
    }
    return normalized.startsWith('+') ? normalized : '+' + normalized;
  };

  // Search across all follow-up statuses (new, ongoing, completed)
  const searchAllFollowUps = async (searchType, searchValue, page = 1) => {
    if (!searchType || !searchValue) {
      return { error: 'Search type and value are required' };
    }

    // Normalize phone number if searching by phone
    let normalizedSearchValue = searchValue;
    if (searchType === 'user_number') {
      normalizedSearchValue = normalizePhoneNumber(searchValue);
    }

    const statuses = ['new', 'ongoing', 'completed'];
    const allResults = [];
    const errors = [];

    // Search each status
    for (const status of statuses) {
      try {
        var url = process.env.REACT_APP_API_URL + `/follow_ups?status=${status}`;
        if (page) url += "&page=" + page;

        // Add search filter
        var filterParam = "";
        switch(searchType) {
          case 'agent_name':
          case 'user_number':
          case 'caller_name':
          case 'follow_up_type':
          case 'twilio_number':
            filterParam = "&" + searchType + '=' + encodeURIComponent(normalizedSearchValue);
            break;
          case 'date_range':
            filterParam = "&" + searchType + '=' + format(searchValue[0], 'yyyy-MM-dd') + ',' + format(searchValue[1], 'yyyy-MM-dd');
            break;
          default:
            filterParam = "&" + searchType + '=' + encodeURIComponent(normalizedSearchValue);
        }
        url += filterParam;

        var options = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: process.env.REACT_APP_API_AUTHORIZATION,
          },
        };

        const result = await fetch(url, options);
        if (!result.ok) {
          throw new Error(`Network response was not ok for status ${status}`);
        }
        const data = await result.json();
        
        // Add status label to each result
        if (data && data.data && Array.isArray(data.data)) {
          const resultsWithStatus = data.data.map(item => ({
            ...item,
            searchStatus: status,
            statusLabel: status === 'new' ? 'New' : status === 'ongoing' ? 'Ongoing' : 'Completed'
          }));
          allResults.push(...resultsWithStatus);
        }
      } catch (err) {
        errors.push({ status, error: err.message });
        console.error(`Error searching ${status} follow-ups:`, err);
      }
    }

    // Also try alternative phone number formats if searching by phone
    if (searchType === 'user_number' && normalizedSearchValue !== searchValue) {
      // Try original format as well
      for (const status of statuses) {
        try {
          var url = process.env.REACT_APP_API_URL + `/follow_ups?status=${status}`;
          if (page) url += "&page=" + page;
          url += "&" + searchType + '=' + encodeURIComponent(searchValue);

          var options = {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: process.env.REACT_APP_API_AUTHORIZATION,
            },
          };

          const result = await fetch(url, options);
          if (result.ok) {
            const data = await result.json();
            if (data && data.data && Array.isArray(data.data)) {
              // Check if we already have this result
              const existingIds = new Set(allResults.map(r => r.id));
              const newResults = data.data
                .filter(item => !existingIds.has(item.id))
                .map(item => ({
                  ...item,
                  searchStatus: status,
                  statusLabel: status === 'new' ? 'New' : status === 'ongoing' ? 'Ongoing' : 'Completed'
                }));
              allResults.push(...newResults);
            }
          }
        } catch (err) {
          // Silently continue
        }
      }
    }

    return {
      data: allResults,
      total_count: allResults.length,
      errors: errors.length > 0 ? errors : undefined
    };
  };
  return (
    <PastoralContext.Provider
      value={{
        followUps,
        followUp,
        getFollowUp,
        updateFollowUp,
        setFollowUp,
        getFollowUps,
        isOnCall,
        setIsOnCall,
        isUpdated,
        setIsUpdated,
        updateResource,
        setFollowUps,
        getCallLogs,
        getResources,
        getCallStats,
        searchValue,
        setSearchValue,
        callSettings,
        setCallSettings,
        isMute,
        setIsMute,
        activeTopBar,
        setActiveTopBar,
        activeSideBar,
        setActiveSideBar,
        seconds,
        setSeconds,
        filter, 
        setFilter,
        getReportsData,
        getRepeatCalls,
        setSort,
        sortOrder,
        getResourcesStatus,
        searchAllFollowUps,
        normalizePhoneNumber
      }}
    >
      {children}
    </PastoralContext.Provider>
  );
};
